module.exports = __webpack_public_path__ + "img/user.ebc32161.svg";